import { IMedicinePrescription } from "@curefit/ehr-common";
import * as _ from "lodash";
import * as React from "react";
import ModelFactory from "../../../models/ModelFactory";
import IMedicineType from "../../../models/staticData/IMedicineType";
import { AppConstants, MedicationTypes } from "../../../utils/AppConstants";
import TemplatedList from "../../TemplatedList";
import CustomHeader, { ICustomHeaderInfo } from "../../utils/CustomHeader";

/**
 * Created by abhinav on 28/01/18.
 */

let CurrentMedicationEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "count", display: ""},
    {label: "name", display: "MEDICINE NAME", mandatory: true},
    {label: "type", display: "TYPE"},
    {label: "dosage", display: "DOSAGE"},
    {label: "at", display: "AT"},
    {label: "frequency", display: "FREQUENCY"},
    /*{label: "weekdays", display: "WEEKDAYS"},*/
    {label: "duration", display: "DURATION"},
    /*{label: "condition", display: "INSTRUCTIONS"}*/
];

let CurrentMedicationEditorHeaderInfosForKMH: ICustomHeaderInfo[] = [
    {label: "count", display: ""},
    {label: "name", display: "MEDICINE NAME", mandatory: true},
    {label: "type", display: "TYPE"},
    {label: "dosage", display: "DOSAGE"},
    {label: "at", display: "AT"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "weekdays", display: "WEEKDAYS"},
    {label: "duration", display: "DURATION"},
    {label: "condition", display: "INSTRUCTIONS"},
    {label: "reminder", display: "REMIND"}
];

let ActiveMedicationEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "count", display: ""},
    {label: "name", display: "MEDICINE NAME", mandatory: true},
    {label: "type", display: "TYPE"},
    {label: "dosage", display: "DOSAGE"},
    {label: "at", display: "AT"},
    {label: "disease", display: "CONDITION"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "since", display: "SINCE"}
];


export interface PatientCurrentMedicationEditorProps {
    staticMedicineTypes: IMedicineType[],
    consultationType?: string,
    medicationType?: string,
    updatedCurrentMedication: {item: IMedicinePrescription}[],
    updateCurrentMedication: (updatedCurrentMedication: {item: IMedicinePrescription}[]) => void,
    activeMedication: IMedicinePrescription[]
}

export interface PatientCurrentMedicationEditorState {
    isActiveMedicationVisible: boolean
}

class PatientCurrentMedicationEditor extends React.Component<PatientCurrentMedicationEditorProps, PatientCurrentMedicationEditorState> {

    constructor(props: PatientCurrentMedicationEditorProps) {
        super(props);
        this.state = {
            isActiveMedicationVisible: false
        }
    }

    onMedicationRemove = (index: number) => {
        let currUpdatedMedication = Object.assign([], this.props.updatedCurrentMedication);
        currUpdatedMedication.splice(index, 1);
        this.props.updateCurrentMedication(currUpdatedMedication);
    }

    onMedicationChange = (updatedMedication: IMedicinePrescription, index: number) => {
        let currUpdatedMedication = Object.assign([], this.props.updatedCurrentMedication);
        currUpdatedMedication[index] = updatedMedication;
        this.props.updateCurrentMedication(currUpdatedMedication);
    }

    addFromActiveToCurrent = (index: number) => {
        let currUpdatedMedication = Object.assign([], this.props.updatedCurrentMedication);
        let activeMedicationToAdd = this.props.activeMedication[index];
        let item: any = {};
        item.inputSource = null;
        item.name = activeMedicationToAdd.genericName;
        item.brand = activeMedicationToAdd.brand.displayValue;
        item.code = activeMedicationToAdd.brand.code;
        item.dosage = activeMedicationToAdd.dosage;
        item.medicineType = activeMedicationToAdd.medicineType;
        item.medicineDuration = null;
        item.slotList = activeMedicationToAdd.slotList;
        if (activeMedicationToAdd.medicineFrequency && typeof activeMedicationToAdd.medicineFrequency === "object") {
            item.medicineFrequency = activeMedicationToAdd.medicineFrequency;
        }
        currUpdatedMedication.push({ item });
        this.props.updateCurrentMedication(currUpdatedMedication);
    }

    render() {
        let consultationType = this.props.consultationType;
        let staticMedicineTypes = this.props.staticMedicineTypes;
        let medicationType = this.props.medicationType !== undefined ? this.props.medicationType : "";
        let headerInfos = medicationType === MedicationTypes.PRESCRIPTION ?
                                            consultationType === AppConstants.ConsultationTypes.KMH ? CurrentMedicationEditorHeaderInfosForKMH : CurrentMedicationEditorHeaderInfos
                                            : ActiveMedicationEditorHeaderInfos;
        return (
            <div className="patient-current-medication-editor">
                <CustomHeader headerInfos={headerInfos} rootCls={"patient-current-medication"}/>
                <TemplatedList templateName={"currentMedication"} commonProps={{medicationType, consultationType, staticMedicineTypes}}
                               defaultItem={{item: ModelFactory.createNewMedication()}}
                               listItems={this.props.updatedCurrentMedication}
                               onItemRemove={this.onMedicationRemove}
                               onItemChange={this.onMedicationChange}/>
                {
                    !_.isEmpty(this.props.activeMedication) && !this.state.isActiveMedicationVisible &&
                    <a onClick={() => this.setState({isActiveMedicationVisible: true})}>View active medications</a>
                }
                {
                    this.state.isActiveMedicationVisible &&
                    <div className={"active-medications"}>
                        <div className={"active-medications-header brandon-bold"}>
                            Active Medications
                            <a onClick={() => this.setState({ isActiveMedicationVisible: false })}>(Hide)</a>
                        </div>
                        {/* {
                            _.map(this.props.activeMedication, (medicine, index) => {
                                return <div key={`active-medication-in-prescription-${index}`}>
                                    <MedicineRowItem medication={medicine} onClickHandler={() => this.addFromActiveToCurrent(index)}/>
                                </div>
                            })
                        } */}
                    </div>
                }
            </div>
        );
    }
}

export default PatientCurrentMedicationEditor